<div [class.svg-image-rendered]="isSVGImageRendered" class="plan-root">
  <div class="hidden-xs can-click" (click)="back()">
    <app-page-title [canGoBack]="true" (click)="back()" [label]="site()?.title"> </app-page-title>
  </div>
  @if (hasLoaded()) {
    <div class="floorplan-container">
      <div class="left no-print">
        @if (hasDashboard()) {
          <div class="can-click" (click)="gotoRelative(['dashboard'])"><i class="mdi mdi-view-dashboard-outline"></i> Dashboard</div>
        }
        <div class="no-print">
          <h4>Floors</h4>
          <div>
            @for (plan of siteFloorplans(); track plan) {
              <div class="can-click" (click)="onClickSitePlanLabel(plan)" [class.selected]="plan.id === planId()">
                {{ plan.title }}
              </div>
            }
          </div>
        </div>
        @if (selected().presentation === 'floorplan' && areas.length) {
          <div class="no-print">
            <h4>Areas</h4>
            <div class="area-list">
              @for (area of areas; track area) {
                <div class="can-click" [class.selected]="selectedArea?.id === area.id" class="can-click" (click)="clickFloorplanLabel(area)">
                  <i class="mdi mdi-eye" (mouseenter)="previewArea(area)" (mouseleave)="previewArea(null)"></i>
                  &nbsp;<span style="color: #e0e0e0">|</span> &nbsp; <span (mouseenter)="onMouseEnterAreaLabel(area)" (mouseleave)="onMouseLeaveAreaLabel(area)">{{ area.title }}</span>
                </div>
              }
            </div>
          </div>
        }
        <div class="no-print">
          <h4>Presentations</h4>
          <div class="can-click" (click)="switchTo('floorplan')" [class.selected]="selected().presentation === 'floorplan'">Plan</div>
          <div class="can-click" (click)="switchTo('table')" [class.selected]="selected().presentation === 'table'">Table</div>
          @if (selected().presentation === 'floorplan' && sitePlanComplete()?.areas.length) {
            <div class="no-print">
              <h4>Areas</h4>
              <div class="area-list">
                @for (area of sitePlanComplete().areas; track area) {
                  <div class="can-click" [class.selected]="selectedArea?.id === area.id" class="can-click" (click)="clickFloorplanLabel(area)">
                    <i class="mdi mdi-eye" (mouseenter)="previewArea(area)" (mouseleave)="previewArea(null)"></i>
                    &nbsp;<span style="color: #e0e0e0">|</span> &nbsp; <span (mouseenter)="onMouseEnterAreaLabel(area)" (mouseleave)="onMouseLeaveAreaLabel(area)">{{ area.title }}</span>
                  </div>
                }
              </div>
            </div>
          }

          @if (selected().presentation === 'table') {
            <h1>Options</h1>
            <ul class="option-list">
              <li>
                <span>From:</span>
                <input class="fourd" type="time" [(ngModel)]="selected().range.startsAt" />
              </li>
              <li>
                <span>To:</span>
                <input class="fourd" type="time" [(ngModel)]="selected().range.endsAt" />
              </li>
              <li>
                <span>Type:</span>
                <select class="fourd" [(ngModel)]="selected().range.type">
                  @for (option of rangeOptions; track $index) {
                    <option value="{{ option.id }}">{{ option.title }}</option>
                  }
                </select>
                <!-- @todo <p-select [options]="rangeOptions" [(ngModel)]="selected().range.type" optionLabel="title" optionValue="id" styleClass="w-full"> </p-select> -->
              </li>
              <li>&nbsp;</li>
              <li>
                <app-button [isBlock]="true" (click)="updateOptions()" label="Update" icon="mdi mdi-refresh" />
              </li>
            </ul>
          }
        </div>
        <div class="weather">
          <h4 title="Weather at site" tooltipPosition="bottom">Site Weather</h4>
          <div class="site-weather">
            <app-weather-temp [site]="site()"></app-weather-temp>
          </div>
        </div>
      </div>

      <div class="plan">
        @if (planId() && sitePlanComplete()?.assets && selected().presentation === 'table') {
          <div class="chart-table">
            <app-site-table [range]="selected().range" [sitePlanComplete]="sitePlanComplete()"> </app-site-table>
          </div>
        }
        @if (planId() && selected().presentation === 'floorplan') {
          <app-site-plan-floorplan-container [config]="{ planId: planId(), siteId }" (onFloorplanLoaded)="floorplanLoaded($event)" />
        }
      </div>
    </div>
  } @else {
    <app-please-wait></app-please-wait>
  }
</div>
